import { useT } from "@/lib/i18n";
import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";
import { PHONE, PHONE_E164 } from "@/lib/data";

export const Navbar = ({ lang, setLang }) => {
  const t = useT(lang);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md bg-[#f7f1e6]/70 border-b border-[#a17a4c]/20"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-2 font-serif-display text-xl sm:text-2xl text-[#4a3520]"
        >
          <span className="inline-block w-2 h-2 rounded-full bg-[#8a6a3f]" />
          Skyline Retreat
        </a>

        <nav className="hidden md:flex items-center gap-8 text-sm">
          <button
            data-testid="nav-cabins"
            onClick={() => scrollTo("cabins")}
            className="nav-link text-[#3d2a1b] hover:text-[#8a6a3f]"
          >
            {t.nav.cabins}
          </button>
          <button
            data-testid="nav-reviews"
            onClick={() => scrollTo("reviews")}
            className="nav-link text-[#3d2a1b] hover:text-[#8a6a3f]"
          >
            {t.nav.reviews}
          </button>
          <button
            data-testid="nav-location"
            onClick={() => scrollTo("location")}
            className="nav-link text-[#3d2a1b] hover:text-[#8a6a3f]"
          >
            {t.nav.location}
          </button>
        </nav>

        <div className="flex items-center gap-2">
          <div
            data-testid="lang-toggle"
            className="hidden sm:flex items-center text-xs rounded-full border border-[#a17a4c]/40 overflow-hidden"
          >
            <button
              data-testid="lang-ro"
              onClick={() => setLang("ro")}
              className={`px-3 py-1.5 transition ${
                lang === "ro"
                  ? "bg-[#8a6a3f] text-[#f7f1e6]"
                  : "text-[#3d2a1b] hover:bg-[#efe5d3]"
              }`}
            >
              RO
            </button>
            <button
              data-testid="lang-en"
              onClick={() => setLang("en")}
              className={`px-3 py-1.5 transition ${
                lang === "en"
                  ? "bg-[#8a6a3f] text-[#f7f1e6]"
                  : "text-[#3d2a1b] hover:bg-[#efe5d3]"
              }`}
            >
              EN
            </button>
          </div>

          <Button
            data-testid="nav-call-btn"
            asChild
            size="sm"
            className="bg-[#8a6a3f] hover:bg-[#7a5d38] text-[#f7f1e6] rounded-full px-4"
          >
            <a href={`tel:${PHONE_E164}`}>
              <Phone className="w-4 h-4 mr-2" />
              <span className="hidden sm:inline">{PHONE}</span>
              <span className="sm:hidden">Sună</span>
            </a>
          </Button>
        </div>
      </div>
    </header>
  );
};
